import Box from './box';

function LayoutProvider(_ref) {
  var children = _ref.children;
  return children;
}

export { Box, LayoutProvider };
export default Box;